module.exports = __webpack_public_path__ + "images/assets/c69d1672cb613f3a222a79e5b2676801.svg";